var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.725 21.1375C5.39167 20.5625 4.225 19.775 3.225 18.775C2.225 17.775 1.4375 16.6083 0.8625 15.275C0.2875 13.9417 0 12.5167 0 11C0 9.48333 0.2875 8.05833 0.8625 6.725C1.4375 5.39167 2.225 4.225 3.225 3.225C4.225 2.225 5.39167 1.4375 6.725 0.8625C8.05833 0.2875 9.48333 0 11 0C12.5167 0 13.9417 0.2875 15.275 0.8625C16.6083 1.4375 17.775 2.225 18.775 3.225C19.775 4.225 20.5625 5.39167 21.1375 6.725C21.7125 8.05833 22 9.48333 22 11C22 12.5167 21.7125 13.9417 21.1375 15.275C20.5625 16.6083 19.775 17.775 18.775 18.775C17.775 19.775 16.6083 20.5625 15.275 21.1375C13.9417 21.7125 12.5167 22 11 22C9.48333 22 8.05833 21.7125 6.725 21.1375ZM17.375 17.375C19.125 15.625 20 13.5 20 11C20 8.5 19.125 6.375 17.375 4.625C15.625 2.875 13.5 2 11 2C8.5 2 6.375 2.875 4.625 4.625C2.875 6.375 2 8.5 2 11C2 13.5 2.875 15.625 4.625 17.375C6.375 19.125 8.5 20 11 20C13.5 20 15.625 19.125 17.375 17.375ZM12 13L10.6 11.6L12 10.175L13.4 11.6L12 13ZM14.55 5.225L12.45 3.1C12.7333 2.81667 13.0833 2.67083 13.5 2.6625C13.9167 2.65417 14.2667 2.8 14.55 3.1C14.8333 3.38333 14.9792 3.7375 14.9875 4.1625C14.9958 4.5875 14.85 4.94167 14.55 5.225Z",
    fill: "#1F1F1F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.1372,
    r: 5,
    stroke: "#1F1F1F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.c27764b381d368efb62fb8ce17cc0052.svg";
export { ForwardRef as ReactComponent };